export const featureList = [
  'Loved by 40+ million learners',
  'Used across 150+ countries',
  'Trusted by over 750,000 teachers'
]